<!-- @format -->

<loading>
  <style>
    .loading {
      visibility: hidden;
      display: table;
      text-align: center;
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.3);
      z-index: 10000;
      transition: all 0.5s;
      opacity: 0;
      background-image: url("/img/Pulse-1s-200px.svg");
      background-repeat: no-repeat;
      background-attachment: fixed;
      background-position: center center;
    }
    .loading.active {
      visibility: visible;
      opacity: 1;
    }
  </style>

  <div class="loading { loadingCount > 0 ? 'active':''}"></div>

  <script>
    import di from "dependeny-injection";

    export default {
      loadingCount: 0,
      onBeforeMount(props, states) {
        di.set(props.diRegisterName ? props.diRegisterName : "loader", this);
      },
      setState(isLoading) {
        this.loadingCount += isLoading ? 1 : -1;
        this.update();
      },
      getState() {
        return this.loadingCount > 0;
      },
    };
  </script>
</loading>